var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-purchase-detail-item",class:{'sign-purchase-detail-item-a': _vm.active},on:{"click":function($event){return _vm.$emit('clickItem', _vm.data)}}},[_c('span',[_vm._v(_vm._s(_vm.data.code + ' ' + (_vm.data.orgName || '') + ' ' + (_vm.data.goodsName || '')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }